import { useEffect, useState } from 'react'
import { jwtDecoder } from 'services/jwtDecoder'
import { useAuthenticationDetails } from './useAuthenticationDetails'

export default function useCompanyId( ): number| undefined {
	const { accessToken } = useAuthenticationDetails()
	const [ companyId, setCompanyId ] = useState<number| undefined>( undefined )

	useEffect(
		() => {
			setCompanyId( accessToken ? parseInt( jwtDecoder( accessToken, 'company_id' ), 10 ) : -1 )
		},
		[ accessToken ]
	)

	return companyId
}
